import { type FC } from "react";
import { List, ListItem, ListItemText, Typography } from "@mui/material";
import { touchTexts } from "./texts";
import {
  emailLabel,
  linkLabel,
  type AttributionTouchView,
} from "./touchSummary";

/** Касание построчно: подпись мелко, значение обычным текстом (как InfoRow карточек). */
export const AttributionTouchList: FC<{
  touch: AttributionTouchView | null | undefined;
  formatDate: (iso: string) => string;
}> = ({ touch, formatDate }) => {
  const rows: [string, string][] = [];
  if (touch?.email) rows.push([touchTexts.email(), emailLabel(touch.email)]);
  if (touch?.link) rows.push([touchTexts.link(), linkLabel(touch.link)]);
  if (touch?.source) rows.push([touchTexts.source(), touch.source]);
  if (touch?.medium) rows.push([touchTexts.medium(), touch.medium]);
  if (touch?.campaign) rows.push([touchTexts.campaign(), touch.campaign]);
  if (touch?.content) rows.push([touchTexts.content(), touch.content]);
  if (touch?.term) rows.push([touchTexts.term(), touch.term]);
  if (touch?.capturedAt)
    rows.push([touchTexts.capturedAt(), formatDate(touch.capturedAt)]);

  if (rows.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        {touchTexts.empty()}
      </Typography>
    );
  }
  return (
    <List dense disablePadding>
      {rows.map(([label, value]) => (
        <ListItem key={label} disableGutters sx={{ py: 0.25 }}>
          <ListItemText
            primary={label}
            secondary={value}
            slotProps={{
              primary: { variant: "caption", color: "text.secondary" },
              secondary: {
                variant: "body2",
                color: "text.primary",
                sx: { wordBreak: "break-word" },
              },
            }}
          />
        </ListItem>
      ))}
      {touch?.backfilled && (
        <ListItem disableGutters sx={{ py: 0.25 }}>
          <Typography variant="caption" color="text.secondary">
            {touchTexts.restored()}
          </Typography>
        </ListItem>
      )}
    </List>
  );
};
